/**
 * Флаг «онбординг персонализации пройден». Используется чтобы
 * показать `<PersonalizationModal>` только при первом входе. После
 * клика «Готово» флаг ставится в `true` и хранится в localStorage.
 *
 * Чтобы пересмотреть онбординг, юзер может удалить ключ
 * `kassir:personalization:done` из localStorage.
 */

import {atomWithStorage} from 'jotai/utils';

const PERSONALIZATION_STORAGE_KEY = 'kassir:personalization:done';

export const personalizationDoneAtom = atomWithStorage<boolean>(
  PERSONALIZATION_STORAGE_KEY,
  false,
  undefined,
  {getOnInit: true},
);
